import request from "@/utils/request";

export default function agentEnableAutoWithdrawMoney() {
    return request({
        url: `/user/agent/agentEnableAutoWithdrawMoney`,
        method: 'post',
    })
}
